/**
 * fetchInChunks — run an id-keyed query in batches.
 *
 * SQLite caps the number of host parameters in a statement, so `Q.oneOf(ids)`
 * blows up past a few hundred ids. Every data source that fans out from a list
 * of ids needs the same batching, so it lives here rather than being re-declared
 * per module.
 *
 * An empty `ids` array performs no query and returns `[]`.
 */

/** Max ids per `Q.oneOf` batch. */
export const CHUNK_SIZE = 500;

export async function fetchInChunks<T>(
  ids: string[],
  run: (batch: string[]) => Promise<T[]>,
  chunkSize: number = CHUNK_SIZE,
): Promise<T[]> {
  const out: T[] = [];
  for (let i = 0; i < ids.length; i += chunkSize) {
    out.push(...(await run(ids.slice(i, i + chunkSize))));
  }
  return out;
}
